const UIStrategy = require('./ui_strategy');
const trackingUtils = require('od-modules/utils/tracking.utils');

class UIStrategyAvailableAtTheAirportSumo4416 extends UIStrategy {
    constructor(bookingInfo, view, templates, keys, constants = {}) {
        super(bookingInfo, view, templates, keys, constants);
    }

    clickMoreInfo() {
        trackingUtils.trackEventWithCategory('my_area_trip_details', 'baggage_offline_no-available', 'baggage_offline_no-available_clicks');
        Odigeo.Router.navigate(`manage-my-booking/add-baggage-with-airline/${this.bookingInfo.tdToken}`);
    }
    getData() {
        const parentData = super.getData();
        return Odigeo._.merge({}, parentData, {
            parent: {
                base: {
                    status: {
                        box: {
                            classes: this.CONST.informativeStatusBoxClasses,
                        },
                        message: {
                            text: this.keys.addBagsAtTheAirportTitleSumo4416,
                            moreinfo: this.keys.addBagsAtTheAirportMoreinfoSumo4416,
                        },
                        icon: {
                            classes: this.CONST.informativeStatusIconClasses,
                        },
                        type: 'bags',
                    },
                },
            },
            child: {
                custom: {
                    clickMoreInfo: this.clickMoreInfo.bind(this),
                },
            },
            bookingInfo: this.bookingInfo,
        });
    }
}

module.exports = UIStrategyAvailableAtTheAirportSumo4416;
